import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBell: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="bell, notification, activity, alert"><path d="M4.58581 9.4153C4.99017 5.62501 8.18819 2.75 12 2.75C15.8118 2.75 19.0098 5.62501 19.4142 9.4153L20.25 17.25H3.75L4.58581 9.4153Z" stroke="currentColor" strokeWidth="1.5"/><path d="M16 17.25C16 19.4591 14.2091 21.25 12 21.25C9.79086 21.25 8 19.4591 8 17.25" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconBell;
